/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { action } from 'mobx';
import get from 'lodash/get';
import profileStore from './profileStore';
import isString from 'lodash/isString';
import { toast, style } from 'react-toastify';
import _ from '../translations';

style({
    //width: "320px",
    //colorDefault: "#fff",
    colorInfo: '#958c8b',
    colorSuccess: '#6ac259',
    /*colorWarning: "#f1c40f",*/
    colorError: '#e95252',
    /*colorProgressDefault: "linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55)",
  mobile: "only screen and (max-width : 480px)",*/
    fontFamily: "'Roboto', sans-serif",
    /*zIndex: 9999,
  TOP_LEFT: {
    top: '1em',
    left: '1em'
  },
  TOP_CENTER: {
    top: '1em',
    marginLeft: `-${320/2}px`,
    left: '50%'
  },
  TOP_RIGHT: {
    top: '1em',
    right: '1em'
  },
  BOTTOM_LEFT: {
    bottom: '1em',
    left: '1em'
  },
  BOTTOM_CENTER: {
    bottom: '1em',
    marginLeft: `-${320/2}px`,
    left: '50%'
  },
  BOTTOM_RIGHT: {
    bottom: '1em',
    right: '1em'
  }*/
});

class ErrorsStore {
    @action.bound
    addError = (error, customMessage = 'There was an error', delay = 10000) => {
        if (isString(error)) {
            error = {
                error: {
                    userMessage: _('Nunchee services are down right now, please try again later'),
                    statusCode: 500,
                },
            };
        }
 
        toast.error(`${customMessage}: ${error.error?.userMessage}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: delay,
        });

        const code = get(error, 'error.statusCode', 0);

        if (parseInt(code / 10, 10) === 401) {
            profileStore.logout();
        }
    };

    @action
    addSuccess = (success, customMessage = '', delay = 10000) => {
        toast.success(`${customMessage}: ${success?.userMessage}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: delay,
        });
    };

    @action
    addInfo = (info, customMessage = '', delay = 10000) => {
        toast.info(`${customMessage}: ${info?.userMessage}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: delay,
        });
    };
}

export default new ErrorsStore();
